module.exports = __webpack_public_path__ + "static/media/cvs-pharmacy1-logo.f370aad4.png";